import React from 'react';
import { Slider, Stack, Typography } from '@mui/material';

export interface SettingsSliderProps {
  label: string;
  value: number;
  onChange: (v: number) => void;
  min: number;
  max: number;
  step?: number;
  unit?: string;
  marks?: Array<{ value: number; label: string }>;
  /** When set, this value renders as the autoLabel (e.g. "Auto") instead of the number. */
  autoValue?: number;
  autoLabel?: string;
  disabled?: boolean;
}

const SettingsSlider: React.FC<SettingsSliderProps> = ({
  label,
  value,
  onChange,
  min,
  max,
  step = 1,
  unit = '',
  marks,
  autoValue,
  autoLabel = 'Auto',
  disabled,
}) => {
  const isAuto = autoValue != null && value === autoValue;
  const displayValue = isAuto ? autoLabel : `${value}${unit}`;

  return (
    <Stack spacing={0}>
      <Stack direction="row" justifyContent="space-between" alignItems="baseline">
        <Typography variant="caption" color="text.secondary">{label}</Typography>
        <Typography variant="caption" color="text.primary" sx={{ fontWeight: 500 }}>
          {displayValue}
        </Typography>
      </Stack>
      <Slider
        size="small"
        value={value}
        onChange={(_, v) => onChange(v as number)}
        min={min}
        max={max}
        step={step}
        marks={marks}
        disabled={disabled}
        valueLabelDisplay="auto"
        valueLabelFormat={(v) =>
          autoValue != null && v === autoValue ? autoLabel : `${v}${unit}`
        }
      />
    </Stack>
  );
};

export default SettingsSlider;
